/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditLedgerEntryOverview
 */
export interface CreditLedgerEntryOverview {
    /**
     * 
     * @type {string}
     * @memberof CreditLedgerEntryOverview
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CreditLedgerEntryOverview
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof CreditLedgerEntryOverview
     */
    invoiceId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreditLedgerEntryOverview
     */
    debitAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreditLedgerEntryOverview
     */
    creditAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreditLedgerEntryOverview
     */
    balance: number;
}

/**
 * Check if a given object implements the CreditLedgerEntryOverview interface.
 */
export function instanceOfCreditLedgerEntryOverview(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "balance" in value;

    return isInstance;
}

export function CreditLedgerEntryOverviewFromJSON(json: any): CreditLedgerEntryOverview {
    return CreditLedgerEntryOverviewFromJSONTyped(json, false);
}

export function CreditLedgerEntryOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditLedgerEntryOverview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'invoiceId': !exists(json, 'invoiceId') ? undefined : json['invoiceId'],
        'debitAmount': !exists(json, 'debitAmount') ? undefined : json['debitAmount'],
        'creditAmount': !exists(json, 'creditAmount') ? undefined : json['creditAmount'],
        'balance': json['balance'],
    };
}

export function CreditLedgerEntryOverviewToJSON(value?: CreditLedgerEntryOverview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'invoiceId': value.invoiceId,
        'debitAmount': value.debitAmount,
        'creditAmount': value.creditAmount,
        'balance': value.balance,
    };
}

